import { render, staticRenderFns } from "./consignmentList.vue?vue&type=template&id=ba638df0&scoped=true"
import script from "./consignmentList.vue?vue&type=script&lang=js"
export * from "./consignmentList.vue?vue&type=script&lang=js"
import style0 from "./consignmentList.vue?vue&type=style&index=0&id=ba638df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba638df0",
  null
  
)

export default component.exports